// Registers /sw.js in production so the app becomes installable
// ("Add to Home Screen"). Skipped in dev to avoid caching hot-reloaded files.
export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Non-fatal — the app works fine without offline caching.
    });
  });
}
